// extracted by mini-css-extract-plugin
export default {"header":"NearByStore_header__QamyI","footer":"NearByStore_footer__d2QWE","content":"NearByStore_content__oM6bB"};